import { createFileRoute } from "@tanstack/react-router"
import { Crumb } from "modules/shared/lib/breadcrumbs"
import { CanonicalSchema, TimeDimensionSchema, TimeFrameEnum, TimeFrameSchema } from "schema"
import { z } from "zod"

const Schema = z.object({
  signals: CanonicalSchema,
  timeFrame: TimeFrameSchema.default(TimeFrameEnum.LastMonth),
  timeDimension: TimeDimensionSchema.optional(),
})

export const Route = createFileRoute("/_base/_auth/insights")({
  loader: ({ route: { fullPath } }) => {
    return new Crumb({
      fullPath,
      title: (t) => t("insights.header.title"),
    })
  },
  validateSearch: (search: Partial<z.infer<typeof Schema>>) => Schema.parse(search),
})
